import { Modal } from 'antd';
import { FC } from 'react';
import styles from './index.module.scss';
import './index.scss';
import { SideDrawerProps } from './types';

const ViewPopUpWrapper: FC<SideDrawerProps> = (props) => {
	const { isPoppedUp, title, children, closeDrawerByAnimation } = props

	const handleCancel = () => {
		closeDrawerByAnimation()
	};

	return (
		<>
			<Modal
				open={isPoppedUp}
				style={{ top: 0, left: 0, margin: 0, right: 0 }}
				centered={false}
				closable={false}
				footer={false}
				className='popUpWrapper'
			>
				<div className={styles['container']}>
					<div>
						<header className={styles['popUpWrapperHeader']}>
							<div className={styles['popUpWrapperHeaderTitle']}>
								<h1>
									{title}
								</h1>
							</div>
							<img src="/assets/images/close.png" alt="" onClick={handleCancel} style={{ cursor: 'pointer' }} />
						</header>

						{children}
					</div>
				</div>

			</Modal>
		</>
	);
};

export default ViewPopUpWrapper;
